/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AuditEventSourceCountResponse } from './AuditEventSourceCountResponse';
import {
    AuditEventSourceCountResponseFromJSON,
    AuditEventSourceCountResponseFromJSONTyped,
    AuditEventSourceCountResponseToJSON,
    AuditEventSourceCountResponseToJSONTyped,
} from './AuditEventSourceCountResponse';
import type { AuditEventCategoryCountResponse } from './AuditEventCategoryCountResponse';
import {
    AuditEventCategoryCountResponseFromJSON,
    AuditEventCategoryCountResponseFromJSONTyped,
    AuditEventCategoryCountResponseToJSON,
    AuditEventCategoryCountResponseToJSONTyped,
} from './AuditEventCategoryCountResponse';
import type { AuditEventCountryCountResponse } from './AuditEventCountryCountResponse';
import {
    AuditEventCountryCountResponseFromJSON,
    AuditEventCountryCountResponseFromJSONTyped,
    AuditEventCountryCountResponseToJSON,
    AuditEventCountryCountResponseToJSONTyped,
} from './AuditEventCountryCountResponse';
import type { AuditEventDailyCountResponse } from './AuditEventDailyCountResponse';
import {
    AuditEventDailyCountResponseFromJSON,
    AuditEventDailyCountResponseFromJSONTyped,
    AuditEventDailyCountResponseToJSON,
    AuditEventDailyCountResponseToJSONTyped,
} from './AuditEventDailyCountResponse';
import type { AuditEventInitiatorCountResponse } from './AuditEventInitiatorCountResponse';
import {
    AuditEventInitiatorCountResponseFromJSON,
    AuditEventInitiatorCountResponseFromJSONTyped,
    AuditEventInitiatorCountResponseToJSON,
    AuditEventInitiatorCountResponseToJSONTyped,
} from './AuditEventInitiatorCountResponse';
import type { AuditEventHourCountResponse } from './AuditEventHourCountResponse';
import {
    AuditEventHourCountResponseFromJSON,
    AuditEventHourCountResponseFromJSONTyped,
    AuditEventHourCountResponseToJSON,
    AuditEventHourCountResponseToJSONTyped,
} from './AuditEventHourCountResponse';
import type { AuditEventIpCountResponse } from './AuditEventIpCountResponse';
import {
    AuditEventIpCountResponseFromJSON,
    AuditEventIpCountResponseFromJSONTyped,
    AuditEventIpCountResponseToJSON,
    AuditEventIpCountResponseToJSONTyped,
} from './AuditEventIpCountResponse';
import type { AuditEventActivityCountResponse } from './AuditEventActivityCountResponse';
import {
    AuditEventActivityCountResponseFromJSON,
    AuditEventActivityCountResponseFromJSONTyped,
    AuditEventActivityCountResponseToJSON,
    AuditEventActivityCountResponseToJSONTyped,
} from './AuditEventActivityCountResponse';

/**
 * 
 * @export
 * @interface AuditEventSummaryResponse
 */
export interface AuditEventSummaryResponse {
    /**
     * 
     * @type {any}
     * @memberof AuditEventSummaryResponse
     */
    totalEvents?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AuditEventSummaryResponse
     */
    failedEvents?: any | null;
    /**
     * 
     * @type {any}
     * @memberof AuditEventSummaryResponse
     */
    distinctActors?: any | null;
    /**
     * 
     * @type {Array<AuditEventDailyCountResponse>}
     * @memberof AuditEventSummaryResponse
     */
    perDay?: Array<AuditEventDailyCountResponse> | null;
    /**
     * 
     * @type {Array<AuditEventActivityCountResponse>}
     * @memberof AuditEventSummaryResponse
     */
    topActivities?: Array<AuditEventActivityCountResponse> | null;
    /**
     * 
     * @type {Array<AuditEventCategoryCountResponse>}
     * @memberof AuditEventSummaryResponse
     */
    perCategory?: Array<AuditEventCategoryCountResponse> | null;
    /**
     * 
     * @type {Array<AuditEventSourceCountResponse>}
     * @memberof AuditEventSummaryResponse
     */
    perSource?: Array<AuditEventSourceCountResponse> | null;
    /**
     * 
     * @type {Array<AuditEventCountryCountResponse>}
     * @memberof AuditEventSummaryResponse
     */
    perCountry?: Array<AuditEventCountryCountResponse> | null;
    /**
     * 
     * @type {Array<AuditEventIpCountResponse>}
     * @memberof AuditEventSummaryResponse
     */
    perIp?: Array<AuditEventIpCountResponse> | null;
    /**
     * 
     * @type {Array<AuditEventInitiatorCountResponse>}
     * @memberof AuditEventSummaryResponse
     */
    perInitiator?: Array<AuditEventInitiatorCountResponse> | null;
    /**
     * 
     * @type {Array<AuditEventHourCountResponse>}
     * @memberof AuditEventSummaryResponse
     */
    perHour?: Array<AuditEventHourCountResponse> | null;
}

/**
 * Check if a given object implements the AuditEventSummaryResponse interface.
 */
export function instanceOfAuditEventSummaryResponse(value: object): value is AuditEventSummaryResponse {
    return true;
}

export function AuditEventSummaryResponseFromJSON(json: any): AuditEventSummaryResponse {
    return AuditEventSummaryResponseFromJSONTyped(json, false);
}

export function AuditEventSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AuditEventSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalEvents': json['totalEvents'] === undefined ? undefined : json['totalEvents'] === null ? null : json['totalEvents'],
        'failedEvents': json['failedEvents'] === undefined ? undefined : json['failedEvents'] === null ? null : json['failedEvents'],
        'distinctActors': json['distinctActors'] === undefined ? undefined : json['distinctActors'] === null ? null : json['distinctActors'],
        'perDay': json['perDay'] === undefined ? undefined : json['perDay'] === null ? null : ((json['perDay'] as Array<any>).map(AuditEventDailyCountResponseFromJSON)),
        'topActivities': json['topActivities'] === undefined ? undefined : json['topActivities'] === null ? null : ((json['topActivities'] as Array<any>).map(AuditEventActivityCountResponseFromJSON)),
        'perCategory': json['perCategory'] === undefined ? undefined : json['perCategory'] === null ? null : ((json['perCategory'] as Array<any>).map(AuditEventCategoryCountResponseFromJSON)),
        'perSource': json['perSource'] === undefined ? undefined : json['perSource'] === null ? null : ((json['perSource'] as Array<any>).map(AuditEventSourceCountResponseFromJSON)),
        'perCountry': json['perCountry'] === undefined ? undefined : json['perCountry'] === null ? null : ((json['perCountry'] as Array<any>).map(AuditEventCountryCountResponseFromJSON)),
        'perIp': json['perIp'] === undefined ? undefined : json['perIp'] === null ? null : ((json['perIp'] as Array<any>).map(AuditEventIpCountResponseFromJSON)),
        'perInitiator': json['perInitiator'] === undefined ? undefined : json['perInitiator'] === null ? null : ((json['perInitiator'] as Array<any>).map(AuditEventInitiatorCountResponseFromJSON)),
        'perHour': json['perHour'] === undefined ? undefined : json['perHour'] === null ? null : ((json['perHour'] as Array<any>).map(AuditEventHourCountResponseFromJSON)),
    };
}

export function AuditEventSummaryResponseToJSON(json: any): AuditEventSummaryResponse {
    return AuditEventSummaryResponseToJSONTyped(json, false);
}

export function AuditEventSummaryResponseToJSONTyped(value?: AuditEventSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalEvents': value['totalEvents'],
        'failedEvents': value['failedEvents'],
        'distinctActors': value['distinctActors'],
        'perDay': value['perDay'] == null ? undefined : ((value['perDay'] as Array<any>).map(AuditEventDailyCountResponseToJSON)),
        'topActivities': value['topActivities'] == null ? undefined : ((value['topActivities'] as Array<any>).map(AuditEventActivityCountResponseToJSON)),
        'perCategory': value['perCategory'] == null ? undefined : ((value['perCategory'] as Array<any>).map(AuditEventCategoryCountResponseToJSON)),
        'perSource': value['perSource'] == null ? undefined : ((value['perSource'] as Array<any>).map(AuditEventSourceCountResponseToJSON)),
        'perCountry': value['perCountry'] == null ? undefined : ((value['perCountry'] as Array<any>).map(AuditEventCountryCountResponseToJSON)),
        'perIp': value['perIp'] == null ? undefined : ((value['perIp'] as Array<any>).map(AuditEventIpCountResponseToJSON)),
        'perInitiator': value['perInitiator'] == null ? undefined : ((value['perInitiator'] as Array<any>).map(AuditEventInitiatorCountResponseToJSON)),
        'perHour': value['perHour'] == null ? undefined : ((value['perHour'] as Array<any>).map(AuditEventHourCountResponseToJSON)),
    };
}

